<template>
  <v-container fluid>
    <!-- <v-row
      align="center"
      justify="center"
    >
      <v-col justify="right">
        <locale-changer class="float-right"/>
      </v-col>
    </v-row> -->
    <v-row
      align="center"
      justify="center"
    >
      <v-col justify="center">
          <v-card
            class="mx-auto pa-6"
            max-width="550px"
            align="center"
          >
            <img
              src="@/assets/logo.webp"
            />
            <template v-if="fulfilled">
              <v-card-text class="text-h5">
                {{ $t('register.completeByLoginWithVerificationCode') }}
              </v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation :disabled="loading" @submit="confirmAccount" onsubmit="return false;">
                <v-card-text class="pa-8 text-center">
                  <v-text-field
                    v-model="email"
                    :label="$t('global.email')"
                    :disabled="true"
                  />
                  <v-text-field
                    v-model="code"
                    :label="$t('login.code')"
                    :rules="codeRules"
                    persistent-hint
                    :hint="$t('login.codeSentByMail')"
                  />
                  <v-btn
                    class="raison-btn"
                    type="submit"
                    :loading="loading"
                  >
                    {{ $t('login.confirm') }}
                    <template v-slot:loader>
                      <span class="rai-custom-loader__button">
                        <v-icon dark>mdi-cached</v-icon>
                      </span>
                    </template>
                  </v-btn>
                </v-card-text>
              </v-form>
            </template>
            <template v-else>
              <v-form
                ref="form"
                v-model="valid"
                :disabled="loading"
                @submit="signup"
                onsubmit="return false;"
              >
                <v-card-text class="text-h5">
                  {{ $t('login.registerYourPersonalAccount') }}
                </v-card-text>
                <v-card-text>

                  <v-text-field
                    v-model="name"
                    :rules="nameRules"
                    label="Name"
                    required
                    autofocus
                  ></v-text-field>

                  <v-text-field
                    v-model="surname"
                    :rules="nameRules"
                    label="Surname"
                    required
                  ></v-text-field>

                  <v-text-field
                    v-model="nickname"
                    :rules="nameRules"
                    label="Nickame"
                    required
                  ></v-text-field>

                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="E-mail"
                    required
                  ></v-text-field>

                  <v-text-field
                    v-model="password"
                    :label="$t('global.password')"
                    :rules="passwordRules"
                    :type="showPassword ? 'text' : 'password'"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPassword = !showPassword"
                    required
                  />

                  <v-text-field
                    v-model="passwordConfirmation"
                    :label="$t('global.passwordConfirmation')"
                    :rules="passwordConfirmationRules"
                    :type="showPassword ? 'text' : 'password'"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPassword = !showPassword"
                  />
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      :disabled="!valid"
                      class="raison-btn"
                      type="submit"
                    >
                    {{ $t('login.register') }}
                  </v-btn>
                </v-card-actions>
              </v-form>

            </template>
          </v-card>

      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { Auth } from '@aws-amplify/auth';
// import LocaleChanger from '@/components/global/LocaleChanger'
import userService from '@/services/users.js'

export default {
  name: "Register",

components: { /* LocaleChanger */ },

  data () {
    return {
      loading: false,
      valid: false,
      fulfilled: false,
      code: '',
      name: '',
      surname: '',
      nickname: '',
      email: '',
      password: '',
      passwordConfirmation: '',
      usagePlan: 'Monthly',
      showPassword: false,
      nameRules: [
        v => !!v || this.$t('global.required'),
        v => /^.{1,100}$/.test(v) || this.$t('global.invalid'),
      ],
      emailRules: [
        v => !!v || this.$t('global.required'),
        v => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v) || this.$t('global.invalid'),
      ],
      codeRules: [
        v => !!v || this.$t('global.required'),
      ],
      passwordRules: [
        v => !!v || this.$t('global.required'),
        v => /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,}$/.test(v) || this.$t('global.invalid'),
      ],
      passwordConfirmationRules: [
        v => !!v || this.$t('global.required'),
        v => v === this.password || this.$t('login.passwordsMismatch')
      ],
    }
  },

  methods: {
    confirmAccount(event) {
      event.preventDefault()
      Auth.confirmSignUp(this.email, this.code)
        .then(() => {
          this.$router.push({ name: 'login' })
        })
        .catch(err => {
          console.log("error : ", err.message);
          this.errorMessage = err.code;
        })
    },
    signup(event) {
      event.preventDefault()
      if(!this.$refs.form.validate()) {
        return
      }
      userService.createUser(this.name, this.surname, this.nickname, this.email, this.password)
        .then(() => {
          // console.log('User created', response)
          this.fulfilled = true
        })
        .catch(err => {
          console.error('Error creating user', err)
          this.$emit('raison-event', { type:'error', messages:[err] })
        })
    }
  }
}
</script>
<style scoped>

</style>
